module.exports = __webpack_public_path__ + "img/404.2db47785.svg";